var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0664 13.2134C23.5597 13.2134 22.2131 13.9467 21.3731 15.0667C20.5331 13.9467 19.1864 13.2134 17.6797 13.2134C15.1331 13.2134 13.0664 15.2934 13.0664 17.8534C13.0664 18.84 13.2264 19.76 13.4931 20.6C14.7997 24.7467 18.8531 27.24 20.8531 27.92C21.1331 28.0134 21.5997 28.0134 21.8797 27.92C23.8797 27.24 27.9331 24.76 29.2397 20.6C29.5197 19.7467 29.6664 18.84 29.6664 17.8534C29.6797 15.2934 27.6131 13.2134 25.0664 13.2134Z",
    fill: "#14904A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.667 11.12C27.667 11.4266 27.3603 11.6266 27.067 11.5466C25.267 11.08 23.2937 11.4666 21.8003 12.5333C21.507 12.7466 21.107 12.7466 20.827 12.5333C19.7737 11.76 18.4937 11.3333 17.147 11.3333C13.707 11.3333 10.907 14.1466 10.907 17.6133C10.907 21.3733 12.707 24.1866 14.5203 26.0666C14.6137 26.16 14.5337 26.32 14.4137 26.2666C10.7737 25.0266 2.66699 19.88 2.66699 11.12C2.66699 7.2533 5.77366 4.1333 9.61366 4.1333C11.8937 4.1333 13.907 5.22663 15.1737 6.91997C16.4537 5.22663 18.467 4.1333 20.7337 4.1333C24.5603 4.1333 27.667 7.2533 27.667 11.12Z",
    fill: "#14904A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovely);
export default __webpack_public_path__ + "static/media/lovely.03649f92049d323269a28e08721bc700.svg";
export { ForwardRef as ReactComponent };